import { atom, useSetRecoilState, useRecoilValue } from 'recoil';
import { ReactNode } from 'react';

export interface NotificationBannerConfig {
  renderContent: () => ReactNode;
  error?: boolean;
}

export type NotificationBannerConfigType = {
  config: NotificationBannerConfig | null;
}

export const AlertHooks = atom<NotificationBannerConfigType>({
  key: 'AlertHooks',
  default: {
    config: null,
  },
});

export const useShowAlertPopup = () => {
  const setState = useSetRecoilState(AlertHooks);
  return (config: NotificationBannerConfig) => setState({ config });
};
export const useDismissAlertPopup = () => {
  const setState = useSetRecoilState(AlertHooks);
  return () => setState({ config: null });
};
export const useAlertPopup: () => [(config: NotificationBannerConfig) => void, () => void] = () => {
  const setState = useSetRecoilState(AlertHooks);
  return [(config: NotificationBannerConfig) => setState({ config }), () => setState({ config: null })];    // const [showAlert, dismissAlert] = useAlertPopup();
};
export const useAlertPopupConfig = () => useRecoilValue(AlertHooks).config;
